export default __webpack_public_path__ + "static/media/shipment.85d9ac3a.svg";